export enum subscriptionBillingMethod {
  auto,
  send,
}
